
"use strict";

var shallowEqualImmutable = require('./shallowEqualImmutable');

var ImmutableRenderMixin = {
  shouldComponentUpdate: function(nextProps, nextState) {
    return !shallowEqualImmutable(this.props, nextProps) ||
           !shallowEqualImmutable(this.state, nextState);
  }
};

module.exports = ImmutableRenderMixin;



//////////////////
// WEBPACK FOOTER
// ./~/react-immutable-render-mixin/ImmutableRenderMixin.js
// module id = 10
// module chunks = 0